export const actionTypePrefix = '@@simpleXHR';
export const reduxKey = '@@simpleXHR';

export enum SimpleXHRMethod {
  GET = 'get',
  POST = 'post',
}

export enum SimpleXHREndpoint {
  GIVE_POINTS = '/points_modal/give',
  GIVE_POINTS_POPUP = '/points_modal',
  GIVE_LLAMA = '/give_llama',
  GIVE_CORE_BADGE = '/corebadge/award',
  GIVE_BADGE = '/badges/give',
  INIT_DEVIATION = '/init',
  SELLER_DISCOUNT_CREATE = '/discounts/create',
  SELLER_DISCOUNT_UPDATE = '/discounts/update',
  SELLER_DISCOUNT_END = '/discounts/end',
  SELLER_DISCOUNT_DELETE = '/discounts/delete',
  WITHDRAW_POINTS = '/earnings/withdraw',
  WITHDRAW_PAYPAL = '/earnings/withdraw/paypal',
  WITHDRAW_STRIPE = '/earnings/withdraw/stripe',
}
